<template>
  <!-- 客户开票信息 -->
  <div class="receipt-info-block" v-if="receiptInfo">
    <h3 style="margin-left: 20px;">客户开票信息</h3>
    <span class="receipt-info-span">
      <b>公司名称: </b>{{ receiptInfo.company_name }}
    </span>
    <span class="receipt-info-span">
      <b>开户行及账号: </b>{{ receiptInfo.bank_info }}
    </span>
    <span class="receipt-info-span">
      <b>地址及电话: </b>{{ receiptInfo.address_phone }}
    </span>
    <span class="receipt-info-span">
      <b>税号: </b>{{ receiptInfo.tax_number }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    receiptInfo: {
      type: Object,
      default: () => {}
    }
  },
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss" scoped>
.receipt-info-block {
  width: 470px;
  margin-bottom: 30px;
  margin-left: 70px;
  border-radius:5px;
  border: 2px solid transparent;
  background-clip: padding-box;
  background-color: rgba(128, 128, 128, 0.1);
}
.receipt-info-span {
  display: block;
  margin-bottom: 5px;
  margin-left: 20px;
}

// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss" module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/InvoiceApplyReceiptInfo.vue